import { logger, TransportFunction, createLogger } from '@codeleap/logger'
import { api } from './api'
import { Settings } from './Settings'

logger.initialize(Settings)

const sentryTransport: TransportFunction = (level, ...args) => {
  try {
    if (level === 'info' || level === 'log') {
      logger.sentry.captureBreadcrumb(
        level,
        '',
        args,
      )
    }

    if (level === 'error') {
      logger.sentry.captureException(args)
    }
  } catch {}
}

const log = createLogger({
  transport: [
    sentryTransport,
  ],
})

logger.debug = log.debug
logger.info = log.info
logger.error = log.error
logger.warn = log.warn
logger.log = log.debug

logger.slack.setApi(api)

// @ts-expect-error
global.logger = logger
